var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "div",
        { staticClass: "bg-white ", staticStyle: { height: "calc(100%)" } },
        [
          _c(
            "el-card",
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: { size: "small", model: _vm.detForm },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目编号：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.detForm.project.proCode)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目名称：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.detForm.project.name)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目单价：" } },
                            [
                              _c("span", [
                                _vm._v(
                                  "$ " +
                                    _vm._s(
                                      _vm.$mathUtil.mathToFixed(
                                        _vm.detForm.price
                                      )
                                    ) +
                                    " / " +
                                    _vm._s(_vm.detForm.unitEn)
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "", label: "项目备注信息：" } },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.detForm.description)),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "项目图片：", prop: "" } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex-row flex-w" },
                                _vm._l(
                                  _vm.detForm.picJsonList,
                                  function (item) {
                                    return _c("el-image", {
                                      key: item.id,
                                      staticStyle: {
                                        width: "100px",
                                        height: "100px",
                                        margin: "0 10px 10px 0",
                                      },
                                      attrs: {
                                        src: item.fileUrl,
                                        "preview-src-list": _vm.srcList,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "tableTitle" }, [_vm._v("材料方案：")]),
          _c(
            "div",
            { staticStyle: { "min-height": "calc(50% - 20px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "cecUnmSetsTable",
                  attrs: {
                    border: "full",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {
                      types: ["csv", "xls", "xlsx"],
                      remote: true,
                    },
                    "sort-config": { remote: true },
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                  on: { "sort-change": _vm.sortChangeHandle },
                },
                [
                  _c("vxe-column", {
                    attrs: {
                      field: "isMain",
                      width: "100",
                      align: "center",
                      title: "材料使用",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.mateKind))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "code",
                      align: "center",
                      width: "100",
                      title: "物品编码",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission(
                              "cecunmusersetmeal:cecUnmUserSetMeal:view"
                            )
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.item
                                          ? scope.row.item.code
                                          : ""
                                      )
                                    ),
                                  ]
                                )
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.item ? scope.row.item.code : ""
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "nameCn",
                      align: "center",
                      "show-overflow": "",
                      title: "中文名称",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.itemId
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.item
                                        ? scope.row.item.nameCn
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.item
                                            ? scope.row.item.nameCn
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.category
                                        ? scope.row.category.name
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.category
                                            ? scope.row.category.name
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "name",
                      align: "center",
                      title: "英文名称",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.itemId
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.item
                                        ? scope.row.item.name
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.item
                                            ? scope.row.item.name
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row.category
                                        ? scope.row.category.nameEn
                                        : "",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "textOverflow" }, [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.category
                                            ? scope.row.category.nameEn
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "name",
                      align: "center",
                      width: "100",
                      title: "材料类别",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: scope.row.item
                                    ? scope.row.item.category.parentIdsName
                                    : "",
                                  placement: "top",
                                },
                              },
                              [
                                _c("div", { staticClass: "textOverflow" }, [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.item
                                        ? scope.row.item.category.name
                                        : ""
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "num",
                      align: "center",
                      width: "100",
                      title: "单价",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "flexBetween" }, [
                              _c("span", [_vm._v("$")]),
                              scope.row.item
                                ? _c("div", [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.price) + " / "),
                                    ]),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.item.units
                                            ? scope.row.item.units.unitEn
                                            : ""
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "rateNum",
                      width: "100",
                      align: "center",
                      title: "损耗率",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.rateNum) + "%"),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "picture",
                      width: "200",
                      align: "center",
                      title: "图片",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.picJsonList
                              ? _c("PopoverTipList", {
                                  attrs: {
                                    labelValue: "id",
                                    tableType: "length",
                                    tableHeight: "500px",
                                    boxWidth: "200",
                                    imageDisabled: true,
                                    columns: [],
                                    selectArray: scope.row.picJsonList,
                                  },
                                })
                              : _c("span", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "rateDesc",
                      align: "center",
                      title: "损耗率描述",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CecItemForm", {
        ref: "cecItemForm",
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }